import transactions from './transactions.accountId';
import transactionsByAccountNumber from './transactions.accountNumber';

export domain from './transactions.domain';

export const entities = {
    transactions,
    transactionsByAccountNumber,
};
